import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandSlack(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="M6.448 14.538a2.015 2.015 0 1 1-4.032 0c0-1.116.901-2.018 2.016-2.018h2.016v2.018ZM7.456 14.538a2.015 2.015 0 1 1 4.032 0v5.044a2.015 2.015 0 1 1-4.032 0v-5.044Z"
        fill="#E01E5A"
      />
      <path
        d="M9.472 6.436a2.015 2.015 0 0 1-2.016-2.018 2.015 2.015 0 1 1 4.032 0v2.018H9.473ZM9.472 7.46c1.116 0 2.017.902 2.017 2.018a2.015 2.015 0 0 1-2.017 2.018H4.417A2.015 2.015 0 0 1 2.4 9.477c0-1.116.902-2.018 2.017-2.018h5.055Z"
        fill="#36C5F0"
      />
      <path
        d="M17.553 9.478a2.015 2.015 0 1 1 4.032 0 2.015 2.015 0 0 1-2.016 2.018h-2.016V9.477ZM16.544 9.478a2.015 2.015 0 1 1-4.032 0v-5.06a2.015 2.015 0 1 1 4.032 0v5.06Z"
        fill="#2EB67D"
      />
      <path
        d="M14.528 17.564c1.115 0 2.016.902 2.016 2.018a2.015 2.015 0 1 1-4.032 0v-2.018h2.016ZM14.528 16.555a2.015 2.015 0 0 1-2.016-2.017c0-1.116.9-2.018 2.016-2.018h5.056c1.115 0 2.016.902 2.016 2.018a2.015 2.015 0 0 1-2.016 2.017h-5.056Z"
        fill="#ECB22E"
      />
    </BaseIcon>
  );
}
